import { getImageUrlFromList } from 'app/libs/content';
import { buildUrl } from 'app/router/helpers/buildUrl';
import { SERIES_PATH } from 'app/router/constants/paths';

const Series = ({ items }) =>
  items?.map(({ id, title, images: { poster_tall: posterTall = [[]] } }) => ({
    id,
    name: title,
    url: buildUrl(`${SERIES_PATH}/${id}`),
    image: getImageUrlFromList({ images: posterTall[0] }),
  }));

export { Series };
